import React, { useState } from "react";

//components material mui
import {
    Button,
    DialogContent,
    DialogActions,
    Typography,
    Box,
    LinearProgress,
} from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

//components
import { DialogoBoostrap } from "../../ControlUsuario/DialogoPersonalizado/DialogoBoostrap";

//hooks
import { useGlobalState } from "../../../Utilidades/useGlobalState";

let funcionAbrirModal;
let validaAbrirModal;
let funcionLoadingModal;

/**
 * Modal "Completa tu pago" (image 2). Muestra el monto a pagar y permite
 * continuar al pago en linea o cancelar.
 *
 * @param {{ monto:(number|string), onIrAPagar:function }} param0
 */
export const DialogoCompletaPago = ({ monto = 0, onIrAPagar = () => {}, sinPasarela = false, onCerrar = () => {} }) => {
    const { etiquetas } = useGlobalState();

    const [abierto, setAbierto] = useState(false);
    const [loading, setLoading] = useState(false);
    funcionAbrirModal = setAbierto;
    validaAbrirModal = abierto;
    funcionLoadingModal = setLoading;

    const lbl = etiquetas?.PagoEnLinea || {};

    const montoFormateado = new Intl.NumberFormat("es-CO").format(Number(monto) || 0);

    return (
        <DialogoBoostrap
            open={abierto}
            // No se cierra por clic en el fondo ni ESC: el usuario perdia el
            // monto/flujo de pago al hacer clic afuera. Solo cierra con los
            // botones Cancelar / Ir a pagar (que llaman setAbierto directo).
            onClose={(event, reason) => {
                if (reason === "backdropClick" || reason === "escapeKeyDown") return;
                setAbierto(false);
            }}
            maxWidth="xs"
            fullWidth
        >
            {loading ? <LinearProgress /> : null}
            <DialogContent style={{ textAlign: "center", padding: "24px" }}>
                <Box
                    style={{
                        display: "inline-flex",
                        padding: 12,
                        borderRadius: 12,
                        backgroundColor: "#EDF0F4",
                        marginBottom: 12,
                    }}
                >
                    <LockOutlinedIcon style={{ color: "#082375", fontSize: 28 }} />
                </Box>
                <Typography style={{ fontWeight: 700, fontSize: 18, marginBottom: 8, color: "#082375" }}>
                    {lbl.Et_TituloModalPago || "Completa tu pago"}
                </Typography>
                <Typography style={{ fontSize: 14, color: "#3F425D", marginBottom: 16 }}>
                    {lbl.Et_DescripcionModalPago || ""}
                </Typography>
                <Box style={{ backgroundColor: "#F3F7FB", borderRadius: 12, padding: "16px", marginBottom: 16 }}>
                    <Typography style={{ fontSize: 13, color: "#3F425D" }}>
                        {lbl.Et_TotalAPagar || "Total a pagar"}
                    </Typography>
                    <Typography style={{ fontWeight: 700, fontSize: 30, color: "#082375" }}>
                        ${montoFormateado} <span style={{ fontSize: 14, fontWeight: 400 }}>COP</span>
                    </Typography>
                </Box>
                <Typography style={{ fontSize: 12, color: "#666666" }}>
                    {sinPasarela ? (lbl.Et_AvisoPagoCajas || "") : (lbl.Et_AvisoRedireccion || "")}
                </Typography>
            </DialogContent>
            <DialogActions style={{ justifyContent: sinPasarela ? "center" : "space-between", padding: "8px 24px 20px" }}>
                {sinPasarela ? (
                    // Sin pasarela disponible: modal informativo. Un unico boton
                    // "Aceptar" que cierra y continua el flujo (redirige), ya que
                    // el pago del PIN de inscripcion se realiza en caja, no en linea.
                    <Button
                        variant="contained"
                        style={{ backgroundColor: "#082375", color: "#FFFFFF" }}
                        onClick={() => {
                            setAbierto(false);
                            onCerrar();
                        }}
                    >
                        {lbl.Et_Aceptar || "Aceptar"}
                    </Button>
                ) : (
                    <React.Fragment>
                        <Button
                            disabled={loading}
                            variant="outlined"
                            style={{ color: "#082375", borderColor: "#082375" }}
                            onClick={() => setAbierto(false)}
                        >
                            {etiquetas?.General?.Et_tbnCancelar || lbl.Et_Cancelar || "Cancelar"}
                        </Button>
                        <Button
                            disabled={loading}
                            variant="contained"
                            endIcon={<ArrowForwardIcon />}
                            style={{ backgroundColor: "#082375", color: "#FFFFFF" }}
                            onClick={async () => {
                                setLoading(true);
                                await onIrAPagar();
                                setLoading(false);
                                setAbierto(false);
                            }}
                        >
                            {lbl.Et_IrAPagar || "Ir a pagar"}
                        </Button>
                    </React.Fragment>
                )}
            </DialogActions>
        </DialogoBoostrap>
    );
};

export const mostrarDialogoCompletaPago = () => {
    funcionAbrirModal(!validaAbrirModal);
    if (validaAbrirModal === false && funcionLoadingModal) {
        funcionLoadingModal(false);
    }
};
